import { render, staticRenderFns } from "./4Step.vue?vue&type=template&id=2c2f94c1&scoped=true&"
import script from "./4Step.vue?vue&type=script&lang=js&"
export * from "./4Step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2f94c1",
  null
  
)

export default component.exports